const initialState = {
    locationForm: JSON.parse(localStorage.getItem('locationForm')) || {},
    allLocation: [],
    getAllRolesList: [],
    deleteLoading : false,
    error: null,
    get_all_location_list: [],
    get_state_code_list: [],
    get_carrier_list: [],
    get_carrier_group_name:[]
  };

  const locationReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_LOCATION_SUCCESS':
        return { ...state, allLocation: action.payload, error: null };
        case 'GET_ALL_ROLES_LIST':
          return { ...state, getAllRolesList: action.payload, error: null };  

          case 'GET_LOCATION_LIST_SUCCESS':
          return { ...state, get_all_location_list: action.payload, error: null }; 
          
          case 'GET_SEARCH_LOCATION_LIST_SUCCESS':
          return { ...state, get_all_location_list: action.payload, error: null }; 

          case 'GET_STATE_CODE_LIST_SUCCESS':
          return { ...state, get_state_code_list: action.payload, error: null };
      
          case 'GET_CARRIER_LIST_SUCCESS':
          return { ...state, get_carrier_group_name: action.payload, error: null };          
          
          case 'GET_STATE_CODE_LIST_SUCCESS':
          return { ...state, get_carrier_list: action.payload, error: null };          
          case 'START_LOADING':
            return {
              ...state,
              deleteLoading: action.service === 'DELETE_LOADING', 
            };
          case 'STOP_LOADING':
            return {
              ...state,
              deleteLoading: false,
            };
          case 'DELETE_LOCATION':
          return { ...state, allLocation: action.payload, error: null };

        case 'SAVE_LOCATION_SUCCESS':
        localStorage.setItem('locationForm', JSON.stringify(action.payload));
        return { ...state, locationForm: action.payload, error: null };
  
          case 'UPDATE_LOCATION_SUCCESS':
            localStorage.setItem('locationForm', JSON.stringify(action.payload));
            return { ...state, locationForm: action.payload, error: null };
          case 'GET_LOCATION_FAILURE':
          case 'SAVE_LOCATION_FAILURE':
          case 'UPDATE_LOCATION_FAILURE':
            return { ...state, error: action.payload };
          default:
        return state;
    }
  };

  export default locationReducer;
